import * as actionTypes from './actionTypes';
import createAction from '@/Framework/State/Redux/createAction';

export const resetRedirect = () => createAction(actionTypes.RESET_REDIRECT);

export const setPageNotFound = (payload: boolean) => createAction(actionTypes.SET_REDIRECT_NOT_FOUND, payload);
